export default {
  INITIAL_CASE_SETUP: 'initial_case_setup',
  PRINTING_REQUEST: 'printing_request',
  FLAWED_TRAY: 'flawed_tray'
};
